import React from "react";

const NotFound = () => <p>not found</p>;

export default NotFound;
